import { ReactNode } from 'react';
import RevisionMenu from './topMenu';

interface IRevisionTemplate {
  children: ReactNode;
}

export default function RevisionTemplate({ children }: IRevisionTemplate) {
  return (
    <div className='flex min-h-screen flex-col'>
      <div className='fixed top-0 z-10 w-full'>
        <RevisionMenu />
      </div>

      <div className='bg-color-lighter mb-[70px] mt-[78px] min-h-screen w-full md:mb-0'>
        {children}
      </div>
    </div>
  );
}
